<template>
  <transition name="modal-fade">
    <!-- eslint-disable-next-line vue/require-toggle-inside-transition -->
    <div class="modal-backdrop" @click="close">
      <div class="modal" :class="{ maximized: isMaximized }" role="dialog" aria-labelledby="modalTitle"
        aria-describedby="modalDescription" @click.stop="">
        <div class="top-right-buttons">
          <font-awesome-icon class="top-right-button"
            :icon="['fas', isMaximized ? 'window-minimize' : 'window-maximize']" @click="isMaximized = !isMaximized" />
          <font-awesome-icon icon="times-circle" class="top-right-button fa-times-circle" @click="close" />
        </div>
        <div class="slot">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const isMaximized = ref(false);

const emit = defineEmits<{
  close: [];
}>();

const close = () => {
  emit('close');
};

</script>

<style lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal {
  color: inherit;
  background: var(--background-color);
  backdrop-filter: blur(10px);
  padding: 10px 20px 0 20px;
  border-radius: 10px;
  box-shadow: 2px 2px 20px 1px #000;
  display: flex;
  flex-direction: column;
  width: 90vw;
  max-width: 1800px;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  outline: none;
  border: 3px solid var(--border-color);
  scrollbar-gutter: stable both-edges;
  scrollbar-width: thin;
  scrollbar-color: #333 #000;

  .editions &,
  .vote-history &,
  .night-reference &,
  .characters & {
    overflow: auto;
    scrollbar-gutter: stable both-edges;
    max-height: 100vh;
  }

  .roles &,
  .characters & {
    max-height: 100vh;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    justify-content: center;
    line-height: 100%;
  }

  >.top-right-buttons {
    position: absolute;
    z-index: 100;
    top: 15px;
    right: 20px;

    >.top-right-button {
      cursor: pointer;
      width: 28px;

      &:hover {
        color: red;
        text-shadow: 0 0 2px black;
      }
    }
  }

  >.slot {
    height: calc(100% - 8em);
    position: initial;
  }
}

.maximized {
  background: black;
  padding: 0;
  border-radius: 0;
  height: 100vh;
  width: 100vw;
  max-width: 100vw;
  display: flex;
  align-content: center;
  justify-content: center;

  &.roles,
  .roles &,
  .characters & {
    max-width: 100%;
    padding: 10px;
  }
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}
</style>
